export const ONBOARDING_BAR_HIDDEN_KEY = "gawronify-onboarding-bar-hidden";
export const ONBOARDING_BAR_PREF_EVENT = "gawronify:onboarding-bar-pref-changed";

export function isOnboardingBarHidden(): boolean {
  try {
    return localStorage.getItem(ONBOARDING_BAR_HIDDEN_KEY) === "1";
  } catch {
    return false;
  }
}

export function setOnboardingBarHidden(hidden: boolean): void {
  try {
    if (hidden) {
      localStorage.setItem(ONBOARDING_BAR_HIDDEN_KEY, "1");
    } else {
      localStorage.removeItem(ONBOARDING_BAR_HIDDEN_KEY);
    }
    window.dispatchEvent(new Event(ONBOARDING_BAR_PREF_EVENT));
  } catch {
    // localStorage unavailable — silently noop
  }
}
